import React, { useEffect, useMemo, useState } from 'react'
import cx from 'classnames'
import Select from '../../../../components/Select'
import Text from '../../../../components/Text'
import IconButton from '../../../../components/IconButton'
import { faXmark } from '@fortawesome/free-solid-svg-icons'
import { MediaCategory } from '../../../../types/Media'
import { treeOptions } from '../../../../helpers/treeOptions'
import { useTranslation } from 'react-i18next'
import styles from './CategoryFilter.module.css'

const CategoryFilter: React.FC<{
    categories: MediaCategory[]
    onChange: (categoryIds: number[]) => void
}> = ({ categories, onChange }) => {
    const [selectedIds, setSelectedIds] = useState<number[]>([])
    const { t } = useTranslation(['settings'])

    const selectOptions = useMemo(() => {
        return treeOptions<MediaCategory>(
            categories,
            null,
            'name',
            'id',
            'parent_id',
            'id',
            0
        )
    }, [categories])

    const onSelect = (category_id: number) => {
        setSelectedIds((prevIds) => [...prevIds, category_id])
    }

    const onRemove = (category_id: number) => {
        setSelectedIds((prevIds) => prevIds.filter((id) => id !== category_id))
    }

    const selectedCategories = useMemo(() => {
        return categories.filter((category) =>
            selectedIds.includes(Number(category.id))
        )
    }, [categories, selectedIds])

    useEffect(() => {
        onChange(selectedIds)
    }, [onChange, selectedIds])

    return (
        <div className={cx(styles['selected-filter'])}>
            <Select
                options={selectOptions}
                onSelect={(_: string, value: string) =>
                    onSelect(parseInt(value))
                }
                property="category"
                value={''}
                placeholder={t('media.filter_by_category')}
                classes={cx(
                    styles['select-element'],
                    'zr-mr-4 zr-mb-6 zr-w-auto sm:zr-mb-0'
                )}
                searchable={true}
                searchTermUpdate={true}
            />
            <div className={cx(styles['selected-categories-filter'])}>
                {selectedCategories.map((category) => (
                    <div
                        key={category.id}
                        className={cx(
                            styles['selected-categories-elements-filter']
                        )}
                    >
                        <Text>{category.name}</Text>
                        <IconButton
                            icon={faXmark}
                            color={'#2f2f2f'}
                            onClick={() => onRemove(Number(category.id))}
                        />
                    </div>
                ))}
            </div>
        </div>
    )
}

export default CategoryFilter
